import React from 'react';
import { Typography } from 'antd';
import PropTypes from 'prop-types';

const { Text } = Typography;

const AppVersion = ({ appVersion, maxAppVersion, minAppVersion }) => {
  const renderAppVersion = () => {
    if (appVersion) {
      return appVersion;
    }
    if (minAppVersion && maxAppVersion) {
      return `${minAppVersion} - ${maxAppVersion}`;
    }
    if (minAppVersion) {
      return `min_${minAppVersion}`;
    }
    if (maxAppVersion) {
      return `max_${maxAppVersion}`;
    }

    return null;
  };

  return <Text>{renderAppVersion()}</Text>;
};

AppVersion.defaultProps = {
  appVersion: null,
  maxAppVersion: null,
  minAppVersion: null,
};

AppVersion.propTypes = {
  appVersion: PropTypes.string,
  maxAppVersion: PropTypes.string,
  minAppVersion: PropTypes.string,
};

export default AppVersion;
